import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="py-8 px-4 bg-brand-cream" data-id="element-60">
      <div className="max-w-xl mx-auto" data-id="element-61">
        <div className="bg-white border border-brand-border p-6 rounded-lg text-center" data-id="element-62">
          <ShieldCheckIcon className="w-12 h-12 text-brand-forest mx-auto mb-4" data-id="element-63" />

          <h3 className="text-xl font-heading font-bold text-brand-forest mb-3" data-id="element-64">
            🛡️ Pruébalo por 14 Días Sin Riesgo
          </h3>

          <p className="text-sm text-brand-text mb-4" data-id="element-65">
            No quiero tu dinero si este protocolo no cambia tu energía. Aplica
            las recetas, usa la lista de compras y prueba los elixires
            desinflamatorios. Si en 14 días no sientes que tu ropa te queda
            mejor o que tu claridad mental ha vuelto, envíanos un email y te
            reembolsaremos el{' '}
            <strong className="text-brand-forest" data-id="element-66">100% de tu inversión</strong>.
            Tú recuperas tu salud o yo no me quedo con un centavo.
          </p>
        </div>
      </div>
    </section>;
}